import LazyLoad from "react-lazyload"

const Breadcrumb = ({breadImage}) => {
    return(
        <>
        <div className="breadcrumb">
          <LazyLoad>  <img src={breadImage} className="img-fluid" alt="Lotus Valley School, Gurgaon" /></LazyLoad>
        </div>
        </>
    )
}
export default Breadcrumb